export default __webpack_public_path__ + "static/media/texture.9d42056f.png";